import { render, staticRenderFns } from "./SentinelCredentialsForm.vue?vue&type=template&id=0b4ee073&scoped=true"
import script from "./SentinelCredentialsForm.vue?vue&type=script&lang=js"
export * from "./SentinelCredentialsForm.vue?vue&type=script&lang=js"
import style0 from "./SentinelCredentialsForm.vue?vue&type=style&index=0&id=0b4ee073&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ee073",
  null
  
)

export default component.exports